import NoDataFound from "js/Component/NoDataFound";
import { memo, useState } from "react";
import dayjs from "dayjs";
import deviceProfile from "images/device.png";
import ExportResponse from './ExportResponse';

/**
 * The Responses component renders a table of responses with user information and actions, allowing
 * users to export data and view details.
 * @param props - The `props` object in the `Responses` component contains two properties:
 * @returns The `Responses` component is being returned. It renders a table with rows displaying user
 * responses. Each row includes the user's name, date responded, and an action icon. The component also
 * includes buttons for exporting data.
 */
const Responses = (props) => {
    const { responsesList, setSelectedResponse, setreLoadData, isTemplate, org } = props;

    const onRowClickHandler = (item) => {
        setSelectedResponse(item);
    };

    const [isExportModel, setisExportModel] = useState(false);
    const onCloseExportModel = () => {
        setisExportModel(false);
    };

    const onOkExportModel = () => {
        setisExportModel(false);
    };

    return (
        <>
            <div className="table-wrap padding_infor_info">
                <div className="form-group">
                    <div className="d-flex justify-content-end align-items-center mb-4">
                        <button class="export-btn" onClick={(e) => { e.preventDefault(); setisExportModel(true) }} disabled={(responsesList && responsesList.length > 0) ? false : true}>
                            Export
                        </button>

                    </div>
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th>CareWindows User</th>
                                <th>Date Responded</th>
                                <th>Actions</th>
                                <th>
                                    <i className="fa fa-refresh" onClick={() => setreLoadData(prev => !prev)} style={{ fontSize: "16px", cursor: "pointer" }} title="Refresh" />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {responsesList?.length > 0 ? (
                                responsesList?.map?.((item) => (
                                    <tr onClick={() => onRowClickHandler(item)} key={item}>
                                        <td style={{ display: "flex", alignItems: "center" }}>
                                            {item.profilePicture ? (
                                                <img className="user-photo" src={`data:image/png;base64, ${item.profilePicture}`} alt={item.name} />
                                            ) : (
                                                <img className="user-photo" src={deviceProfile} alt="Default profile" />
                                            )}
                                            {item?.name} {isTemplate === true && (" - " + item?.formName)}
                                        </td>
                                        <td style={{ verticalAlign: "middle" }}>{dayjs(item?.createdAt).format("DD/MM/YYYY")}</td>
                                        <td style={{ verticalAlign: "middle" }}>
                                            {/*{*/}
                                            {/*    <i className="fa fa-phone" style={{ cursor: "pointer" }}></i>*/}
                                            {/*}*/}
                                        </td>
                                        <td></td>
                                    </tr>
                                ))
                            ) : (
                                <NoDataFound />
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <ExportResponse visible={isExportModel} onClose={onCloseExportModel} onOkPress={onOkExportModel} org={org} responsesList={responsesList} />
        </>
    );
};

export default memo(Responses);
